module.exports = __webpack_public_path__ + "img/6-7.03ada50d.png";